<template>
  <v-row dense>
    <v-col cols="12">
      <a-motpasse-field
        label="Mot de passe"
        v-model="motPasse"
        filled
        :rules="[requiredRule(), serverRule('motPasse')]"
        @input="notify('motPasse')"
        hint="Au moins 10 caractères, dont une majuscule et un caractère spécial."
        counter
        data-testid="mot-de-passe"
      />
    </v-col>
  </v-row>
</template>

<script>
import makeValueData from "@/mixins/makeValueData";
import makeRules from "@/mixins/makeRules";
import ValueDataRules from "@/mixins/ValueDataRules";

function mapTo(src, dest) {
  dest.motPasse = src.motPasse;
}

export default {
  mixins: [makeRules(), makeValueData(mapTo), ValueDataRules],
};
</script>
